import * as React from "react";
import SupplierServices from "../supplier-services";
export default class Services extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(SupplierServices, Object.assign({}, this.props)));
    }
}
;
//# sourceMappingURL=services.js.map